import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import {  CommonResponseModel, Divisionreq } from "@project-management-system/shared-models";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";
import { divisionEntity } from "./division-entity";

@Injectable()
export class DivisionService {
  constructor(
    @InjectRepository(divisionEntity)
    private repo: Repository<divisionEntity>
  ) {}

  async createDivision(
    data: Divisionreq,
    isUpdate: boolean
  ): Promise<CommonResponseModel> {
    try {
      if(!isUpdate){
        const duplicate = await this.repo.findOne({where:{division:data.division}})
        // console.log(duplicate,'duplicatee')
  
        if(duplicate){
          return new CommonResponseModel(false,0,'Division Already Exists')
        }
      }else{
        const duplicate = await this.repo.findOne({where:{division:data.division}})
        if(duplicate){
          if(duplicate.id != data.id){
            return new CommonResponseModel(false,0,'Division Already Exists')
          }
        }

      }
    
      const roles = new divisionEntity();
      roles.division = data.division;
   //   roles.plantId = data.plantId;
      roles.isActive = data.isActive;
      if (isUpdate) {
        roles.id = data.id;
        roles.updatedUser = data.updatedUser;
      } else {
        roles.createdUser = data.createdUser;
      }
      const save = await this.repo.save(roles);
      if (save) {
        return new CommonResponseModel(
          true,
          0,
          isUpdate ? "Roles Updated Successfully" : "Roles Created Successfully"
        );
      }
    } catch (error) {
      throw error;
    }
  }

  async getAllActiveDivision(): Promise<CommonResponseModel> {
    const data = await this.repo.find({
        where: {
            isActive: true
        }
    })

    if (data.length > 0) {
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
    }
    return new CommonResponseModel(true, 1, 'No Data Found', [])
}



  async getAllDivision(): Promise<CommonResponseModel> {
    const data = await this.repo.find();
    if (data) {
      return new CommonResponseModel(true, 1, "Data Retrived", data);
    } else {
      return new CommonResponseModel(false, 0, "Data Retrived");
    }
  }

  async activateOrDeactivateDivision(req: Divisionreq): Promise<CommonResponseModel> {
    // add dto
    try {
      // console.log(req.isActive, "service-----------");
      const Exists = await this.repo.findOne({
        where: { id: req.id },
      });
      if (Exists) {
        if (!Exists) {
          throw new ErrorResponse(
            10113,
            "Someone updated the current Division information.Refresh and try again"
          );
        } else {
          const update = await this.repo.update(
            { id: req.id },
            { isActive: req.isActive, updatedUser: req.updatedUser }
          );
          if (Exists.isActive) {
            if (update.affected) {
              const Response: CommonResponseModel = new CommonResponseModel(
                true,
                10115,
                "Division is Deactivated successfully"
              );
              return Response;
            } else {
              throw new CommonResponseModel(
                false,
                10111,
                "Division is already deactivated"
              );
            }
          } else {
            if (update.affected) {
              const Response: CommonResponseModel = new CommonResponseModel(
                true,
                10114,
                "Division is activated successfully"
              );
              return Response;
            } else {
              throw new CommonResponseModel(
                false,
                10112,
                "Division is already  activated"
              );
            }
          }
        }
      } else {
        throw new CommonResponseModel(false, 99998, "No Records Found");
      }
    } catch (err) {
      return err;
    }
  }

}
